import React, { useCallback, useEffect, useRef, useState } from "react";
import styles from './index.module.css';
import { useDispatch, useSelector } from "react-redux";
import { addNewStaffMember, addUserCertificateEntity, editStaffMember, editStaffMemberPassword, getAllStaffMembers } from "../../../redux/features/staff/staffService";
import { showToast } from "../../../components/ToastMsg";
import BeatLoader from "react-spinners/BeatLoader";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEyeSlash } from '@fortawesome/free-regular-svg-icons';
import { faEye } from '@fortawesome/free-regular-svg-icons';
import { faCircleCheck, faCircleXmark, faLock, faXmark } from "@fortawesome/free-solid-svg-icons";
import Modal from "../../../components/Modal";
import Pagination from "../../../components/Pagination";
import NoResultsFound from "../../../components/NoResultsFound";
import SearchBar from "../../../components/SearchBar";
import TableSkeleton from "../../../components/Skeleton";
import Dropdown from "../../../components/Dropdown/Dropdown";
import { getActiveRoles } from "../../../redux/features/role/roleService";
import { selectActiveRoles } from "../../../redux/features/role/roleSlice";
import { selectActiveCertificateList } from "../../../redux/features/certificateEntity/certificateEntitySlice";
import { getActiveCertificateEntities } from "../../../redux/features/certificateEntity/certificateEntityService";
import { useNavigate } from "react-router-dom";

const Roles = [
    { id: '1', name: 'Admin' },
    { id: '2', name: 'Exam Controller' },
    { id: '3', name: 'Exam Controller Assistant' },
    { id: '4', name: 'User' }]

const Staff = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const roleDropdownRef = useRef(null);
    const entityDropdownRef = useRef(null);

    const { isStaffMembersLoading, pageCount, staffMembers } = useSelector((state) => state.staff.allStaffMembers);
    const { isStaffMemberCreating } = useSelector((state) => state.staff.newStaffMember);
    const { isEditingStaffMember } = useSelector((state) => state.staff.editedStaffMember);
    const { roles } = useSelector(selectActiveRoles);
    const { status, data: activeCertificateEntities } = useSelector(selectActiveCertificateList);

    const [formData, setFormData] = useState({
        full_name: '',
        email: '',
        phone_number: '',
        password: '',
    });

    const [errorMessages, setErrorMessages] = useState({});
    const [disabledBtn, setBtnDisable] = useState(false);
    const [skip, setSkip] = useState(0);
    const [passwordVisible, setPasswordVisible] = useState(false);

    const limit = 25;
    const [isModalOpen, setModalOpen] = useState(false);
    const [selectedStaffMember, setSelectedStaffMember] = useState(null);
    const [initialStaffMember, setInitialStaffMember] = useState(null);
    const [editErrorMsgs, setEditErrorMsgs] = useState({
        name: '',
        staffMember_code: ''
    });
    const [selectedRole, setSelectedRole] = useState({
        id: '',
        name: ''
    });

    const [disabledEditBtn, setEditBtnDisable] = useState(false);
    const [errorMsg, setErrorMsg] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [isFirst, setFirst] = useState(true);
    const [isSecond, setSecond] = useState(false);

    
    const [changePasswordVisible, setChangePasswordVisible] = useState(false);
    const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
    const [isPasswordModalOpen, setPasswordModalOpen] = useState(false);
    const [selectedPasswordStaffMember, setSelectedPasswordStaffMember] = useState(null);
    const [passwordChangeError, setPasswordChangeError] = useState({
        passowrd: '',
        confirm_password: ''
    });
    const [disabledPasswordBtn, setDisabledPasswordBtn] = useState(false);

    const fetchAllStaffMembers = useCallback(() => {
        dispatch(getAllStaffMembers({
            skip: skip,
            limit,
            search: searchQuery,
        }));
    }, [dispatch, skip, searchQuery]);

    useEffect(() => {
        fetchAllStaffMembers();
    }, [fetchAllStaffMembers]);

    useEffect(() => {
        dispatch(getActiveRoles());
        dispatch(getActiveCertificateEntities());
    }, [dispatch]);

    const handleSelect = (option) => {
        setFormData({ ...formData, role_name: option.name });
        setErrorMessages({ ...errorMessages, role: "" });
        setSelectedRole({
            id: option.id,
            name: option.name
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));

        setErrorMessages((prev) => ({
            ...prev,
            [name]: '',
        }));
    };

    // Validate input
    const isValidStaffMember = () => {
        const errors = {};
        const trimmedName = formData.full_name.trim();
        if (!trimmedName) {
            errors.full_name = "Name is required.";
        }
        if (!formData.email) {
            errors.email = "Email is required.";
        } else if (!/^[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/.test(formData.email)) {
            errors.email = "Invalid email format.";
        }
        if (!formData.phone_number) {
            errors.phone_number = "Phone Number is required.";
        }
        if (!formData.role_name) {
            errors.role = "Role is required.";
        }
        if (!formData.password) {
            errors.password = "Password is required.";
        }
        if (Object.keys(errors).length > 0) {
            setErrorMessages(errors);
            return false;
        } else {
            return true;
        }
    };

    const [selectedUserId, setSelectedUserId] = useState(null);
    const [roleEntityCount, setRoleEtityCount] = useState(0);

    const insertNewStaffMember = async () => {
        // setFirst(false);
        // setSecond(true);
        if (isValidStaffMember()) {
            setBtnDisable(true);
            try {
                if (formData.role_name === 'Admin') {
                    formData.role_name = 'admin'
                }
                if (formData.role_name === 'Entity Admin') {
                    formData.role_name = 'entity_admin'
                }
                if (formData.role_name === 'Exam Controller') {
                    formData.role_name = 'exam_controller'
                }
                if (formData.role_name === 'Auditor') {
                    formData.role_name = 'auditor'
                }
                if (formData.role_name === 'Viewer') {
                    formData.role_name = 'viewer'
                }
                if (formData.role_name === 'Certificate Issuer') {
                    formData.role_name = 'certificate_issuer'
                }
                const response = await dispatch(addNewStaffMember(formData)).unwrap();
                if (response.success === true) {
                    setSelectedUserId(response?.user?.id);
                    setRoleEtityCount(response?.user?.role?.entity_count);
                    setFirst(false);
                    setSecond(true);
                }
                setBtnDisable(false);
                setFormData({
                    full_name: '',
                    email: '',
                    phone_number: '',
                    password: '',
                });
                setSelectedRole({
                    id: '',
                    name: ''
                });
                if (roleDropdownRef.current) {
                    roleDropdownRef.current.clearSelection();
                }
                fetchAllStaffMembers();
                showToast('success', response.message);
            }
            catch (error) {
                setBtnDisable(false);
                showToast('error', error.message);
            };
        }
    };

    // Edit staffMember
    const handleSelectedStaffMemberChange = (e) => {
        const { name, value } = e.target;
        setErrorMsg(null);
        setSelectedStaffMember((prev) => ({
            ...prev,
            [name]: value,
        }));

        setEditErrorMsgs((prev) => ({
            ...prev,
            [name]: '',
        }));
    };

    const isValidEditStaffMember = () => {
        const errors = {};
        const trimmedName = selectedStaffMember.full_name.trim();

        if (!trimmedName) {
            errors.full_name = "Name is required.";
        }
        if (!selectedStaffMember.phone_number) {
            errors.phone_number = "Phone Number is required.";
        }
        if (Object.keys(errors).length > 0) {
            setEditErrorMsgs(errors);
            return false;
        } else {
            return true;
        }
    };

    function getChangedValues(selectedData) {
        const changedValues = {};
        for (const key in selectedData) {
            if (
                key !== 'id' &&
                selectedData.hasOwnProperty(key) &&
                selectedData[key] !== initialStaffMember[key]
            ) {
                changedValues[key] = selectedData[key];
            }

            if (key === 'id') {
                changedValues[key] = selectedData[key];
            }
        }
        return changedValues;
    }

    const editStaffMemberDetails = async () => {
        if (isValidEditStaffMember(selectedStaffMember)) {
            const data = getChangedValues(selectedStaffMember);
            const hasChanges = Object.keys(data).some(key => key !== 'id');
            if (!hasChanges) {
                setErrorMsg('There are no changes to update.');
            } else {
                setEditBtnDisable(true);
                try {
                    const response = await dispatch(editStaffMember(data)).unwrap();
                    setEditBtnDisable(false);
                    setSelectedStaffMember(null);
                    setInitialStaffMember(null);
                    setModalOpen(false);
                    showToast('success', response.message);
                    fetchAllStaffMembers();
                }
                catch (error) {
                    setEditBtnDisable(false);
                    showToast('error', error.message);
                };
            }
        }
    };

    //Activate StaffMember
    const [isActivateModalOpen, setActivateModalOpen] = useState(false);
    const [isDeactivationModalOpen, setDeactivationModalOpen] = useState(false);
    const [selectedStaffMemberId, setSelectedStaffMemberId] = useState(null);

    const closeModal = () => setActivateModalOpen(false);
    const closDeactivationModal = () => setDeactivationModalOpen(false);

    const handleYes = async () => {
        setActivateModalOpen(false);
        try {
            const response = await dispatch(editStaffMember({ id: selectedStaffMemberId, status: 'Active' })).unwrap();
            setSelectedStaffMemberId(null);
            setInitialStaffMember(null);
            showToast('success', response.message);
            fetchAllStaffMembers();
        }
        catch (error) {
            showToast('error', error.message);
        };
    }
    const handleRejectYes = async () => {
        setDeactivationModalOpen(false);
        try {
            const response = await dispatch(editStaffMember({ id: selectedStaffMemberId, status: 'Deactivated' })).unwrap();
            setSelectedStaffMemberId(null);
            setInitialStaffMember(null);
            showToast('success', response.message);
            fetchAllStaffMembers();
        }
        catch (error) {
            showToast('error', error.message);
        };
    }

    // Pagination
    const handlePageChange = (pageNumber) => {
        setSkip(pageNumber - 1);
    };

    // Certificate entities

    const [selectedEntity, setSelectedEntity] = useState({
        id: '',
        name: ''
    });
    const [selectedEntities, setSelectedEntities] = useState([]);
    const [entityError, setEntityError] = useState('');
    const [disabledEntityCreate, setDisableEntityCreate] = useState(false);

    const handleSelectEntity = (entity) => {
        setEntityError('');

        setSelectedEntities((prev) => {

            // prevent duplicate
            const alreadyExists = prev.some(
                (item) => item.certificate_entity_id === entity.id
            );

            if (alreadyExists) return prev;

            // check max count using latest state
            if (prev.length >= roleEntityCount) {
                setEntityError('Maximum entity count is reached.');
                return prev;
            }

            const newEntity = {
                user_id: selectedUserId,
                certificate_entity_id: entity.id,
                certificate_entity_name: entity.name,
            };

            return [...prev, newEntity];
        });
    };

    const handleRemoveEntity = (id) => {
        setEntityError('');
        setSelectedEntities((prev) =>
            prev.filter((item) => item.certificate_entity_id !== id)
        );
    };

    const insertEntities = async () => {
        if (selectedEntities.length < 1) {
            setEntityError('Select at least on entity.');
            return
        }
        try {
            setDisableEntityCreate(true);
            const payload = {
                create_user_certificate_entities: selectedEntities.map((item) => ({
                    user_id: item.user_id,
                    certificate_entity_id: item.certificate_entity_id,
                }))
            };
            const response = await dispatch(addUserCertificateEntity(payload)).unwrap();
            showToast('success', response.message);
            setSelectedEntity({
                id: '',
                name: ''
            });
            setSelectedEntities([]);
            if (entityDropdownRef.current) {
                entityDropdownRef.current.clearSelection();
            }
            setSecond(false);
            setFirst(true);
            setDisableEntityCreate(false);
        } catch (error) {
            showToast('error', error);
            setDisableEntityCreate(false);
        }
    }

    const navigateToStaffMemebrPage = (id) => navigate(`/admin/staff/${id}`);

    // Edit staff password
    
    const [passwordChangeData, setPasswordChangeData] = useState({
        password: ''
    });

    const handlePasswordInputChange = (e) => {
        const { name, value } = e.target;
        setPasswordChangeData((prev) => ({
            ...prev,
            [name]: value,
        }));
        setPasswordChangeError((prev) => ({
            ...prev,
            [name]: '',
        }));
    };

    const isValidPasswordChange = () => {
        const errors = {};
            if (!passwordChangeData.password) {
                errors.password = 'Password is required.'
            }
            if (!passwordChangeData.confirm_password) {
                errors.confirm_password = 'Password is required.'
            }
            else if (passwordChangeData.password !== passwordChangeData.confirm_password) {
                errors.confirm_password = 'Password and Confirm password should be matched.'
            }
        if (Object.keys(errors).length > 0) {
            setPasswordChangeError(errors);
            return false;
        } else {
            return true;
        }
    };

    const handleChangeStaffPassword = async () => {
        if (!selectedPasswordStaffMember) return;
        if (!isValidPasswordChange()) return;

        setDisabledPasswordBtn(true);
        try {
            const payload = {
                user_id: selectedPasswordStaffMember.id,
                new_password: passwordChangeData.password.trim(),
                confirm_password: passwordChangeData.confirm_password.trim(),
            };

            const response = await dispatch(editStaffMemberPassword(payload)).unwrap();
            setDisabledPasswordBtn(false);
            setPasswordModalOpen(false);
            setPasswordChangeData({ password: '' });
            setSelectedPasswordStaffMember(null);
            showToast('success', response.message);
            fetchAllStaffMembers();
        }
        catch (error) {
            setDisabledPasswordBtn(false);
            showToast('error', error.message);
        };
    };

    return (
        <div className={`card-section`}>
            <div className={`main-card`}>
                <h1 className={`form-title`}>Add New Staff Member</h1>
                <div className={styles.formContainer}>
                    {isFirst &&
                        <form
                            className={styles.coordinatorForm}
                            noValidate
                        >
                            <div className={`form-input-row`}>
                                <div className={`form-input-col md-col`}>
                                    <div className={`form-input-group`}>
                                        <label htmlFor='full_name' className={`form-label`}>
                                            Full Name<span className={`required-star`}>*</span>
                                        </label>
                                        <input
                                            type='text'
                                            id='full_name'
                                            name='full_name'
                                            value={formData.full_name}
                                            onChange={handleInputChange}
                                            placeholder='Enter Name'
                                            className={`form-input-default`}
                                        />
                                        {errorMessages.full_name && (
                                            <p className={`text-danger`}>{errorMessages.full_name}</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className={`form-input-row`}>
                                <div className={`form-input-col md-col`}>
                                    <div className={`form-input-group`}>
                                        <label htmlFor='full_name' className={`form-label`}>
                                            Email Address<span className={`required-star`}>*</span>
                                        </label>
                                        <input
                                            type='text'
                                            id='email'
                                            name='email'
                                            value={formData.email}
                                            onChange={handleInputChange}
                                            placeholder='Enter Email'
                                            className={`form-input-default`}
                                        />
                                        {errorMessages.email && (
                                            <p className={`text-danger`}>{errorMessages.email}</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className={`form-input-row`}>
                                <div className={`form-input-col md-col`}>
                                    <div className={`form-input-group`}>
                                        <label htmlFor='full_name' className={`form-label`}>
                                            Phone Number<span className={`required-star`}>*</span>
                                        </label>
                                        <input
                                            type='text'
                                            id='phone_number'
                                            name='phone_number'
                                            value={formData.phone_number}
                                            onChange={handleInputChange}
                                            placeholder='Enter Phone Number'
                                            className={`form-input-default`}
                                        />
                                        {errorMessages.phone_number && (
                                            <p className={`text-danger`}>{errorMessages.phone_number}</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className={`form-input-row`}>
                                <div className={`form-input-col md-col`}>
                                    <div className={`input-group`} style={{ marginTop: '0' }}>
                                        <label htmlFor='full_name' className={`form-label`}>
                                            Password<span className={`required-star`}>*</span>
                                        </label>
                                        <input
                                            type={passwordVisible ? "text" : "password"}
                                            id='password'
                                            name='password'
                                            value={formData.password}
                                            onChange={handleInputChange}
                                            placeholder='Enter Password'
                                            className={`${styles.loginInput} form-input-default`}
                                        />
                                        {!passwordVisible ?
                                            <FontAwesomeIcon icon={faEyeSlash} style={{ marginLeft: '-40px' }} onClick={() => setPasswordVisible(true)} /> :
                                            <FontAwesomeIcon icon={faEye} style={{ marginLeft: '-40px' }} onClick={() => setPasswordVisible(false)} />}

                                        {errorMessages.password && (
                                            <p className={`text-danger`}>{errorMessages.password}</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className={`form-input-row`}>
                                <div className={`form-input-col md-col`}>
                                    <div className={`form-input-group`}>
                                        <label htmlFor='full_name' className={`form-label`}>
                                            Role<span className={`required-star`}>*</span>
                                        </label>
                                        <Dropdown
                                            ref={roleDropdownRef}
                                            options={roles?.map(role => ({
                                                ...role,
                                                name: role.name
                                                    .split('_')
                                                    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                                                    .join(' ')
                                            }))}
                                            placeholder="Choose an Option"
                                            onSelect={handleSelect}
                                            value={selectedRole.name}
                                        />
                                        {errorMessages.role && (
                                            <p className={`text-danger`}>{errorMessages.role}</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <button
                                className={`btn-primary`}
                                type='button'
                                disabled={disabledBtn}
                                onClick={insertNewStaffMember}
                            >
                                {isStaffMemberCreating ? <BeatLoader color='#ffffff' /> : `Next`}
                            </button>
                        </form>
                    }
                    {isSecond &&
                        <form
                            className={styles.coordinatorForm}
                            noValidate
                        >
                            <div className={`form-input-row`}>
                                <div className={`form-input-col md-col`}>
                                    <div className={`form-input-group`}>
                                        <label htmlFor='full_name' className={`form-label`}>
                                            Certificate Entity<span className={`required-star`}>*</span>
                                        </label>
                                        <Dropdown
                                            ref={entityDropdownRef}
                                            options={activeCertificateEntities}
                                            placeholder="Select an Entity"
                                            onSelect={handleSelectEntity}
                                            value={selectedEntity.name}
                                        />
                                        {entityError && (
                                            <p className={`text-danger`}>{entityError}</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className={styles.selectedEntitiesWrapper}>
                                {selectedEntities.map((entity) => (
                                    <div key={entity.certificate_entity_id} className={styles.entityCard}>
                                        <p>{entity.certificate_entity_name}</p>
                                        <button
                                            type="button"
                                            onClick={() => handleRemoveEntity(entity.certificate_entity_id)}
                                            className={styles.removeBtn}
                                        >
                                            ✕
                                        </button>
                                    </div>
                                ))}
                            </div>
                            <button
                                className={`btn-primary`}
                                type='button'
                                disabled={disabledEntityCreate}
                                onClick={insertEntities}
                            >
                                {disabledEntityCreate ? <BeatLoader color='#ffffff' /> : `Create`}
                            </button>
                        </form>}
                </div>
            </div>
            <div className={`search-card`}>
                <div className={`search-card-header`}>
                    <h1 className={`form-title`}>Staff Members</h1>
                    <SearchBar onSearch={(query) => setSearchQuery(query)} />
                </div>
                <div className={`search-card-body`}>
                    {isStaffMembersLoading ?
                        <TableSkeleton columns={["Full Name", "Email", "Phone Number", "Role", "Status", "Actions"]} rowCount={10} height={20} />
                        : staffMembers.length > 0 ?
                            <div className={`table-container`}>
                                <table className={`table`}>
                                    <thead className={`thead`}>
                                        <tr>
                                            <th className={`theadColumnOne`}>Full Name</th>
                                            <th>Email</th>
                                            <th>Phone Number</th>
                                            <th>Role</th>
                                            <th>Status</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody className={`tbody`}>
                                        {staffMembers?.map((staffMember) => (
                                            <tr key={staffMember.id}>
                                                <td className={`tdataColumnOne`}>
                                                    {staffMember.full_name}
                                                </td>
                                                <td>{staffMember.email}</td>
                                                <td>{staffMember.phone_number}</td>
                                                <td>{staffMember.role.name === 'admin' ? 'Admin' :
                                                    staffMember.role.name === 'exam_controller' ? 'Exam Controller' :
                                                        staffMember.role.name === 'exam_controller_assistant' ? 'Exam Controller Assistant' :
                                                            staffMember.role.name === 'entity_admin' ? 'Entity Admin' :
                                                                staffMember.role.name === 'auditor' ? 'Auditor' :
                                                                    staffMember.role.name === 'certificate_issuer' ? 'Certificate Issuer' :
                                                                        staffMember.role.name === 'viewer' ? 'Viewer' :
                                                                            'User'}</td>
                                                <td>{staffMember.status}</td>
                                                <td className={`actionsBtn`}>
                                                    <button className={`btn-edit-label`} onClick={() => {
                                                        setSelectedPasswordStaffMember(staffMember);
                                                        setPasswordChangeData({ password: '' });
                                                        setPasswordChangeError('');
                                                        setPasswordModalOpen(true);
                                                    }}><FontAwesomeIcon icon={faLock} /></button>
                                                    <button className={`btn-edit-label`} onClick={() => {
                                                        setSelectedStaffMember(staffMember);
                                                        setInitialStaffMember(staffMember);
                                                        setEditBtnDisable(false);
                                                        setErrorMsg(null);
                                                        setEditErrorMsgs({
                                                            name: '',
                                                            staffMember_code: ''
                                                        })
                                                        setModalOpen(true);
                                                        navigateToStaffMemebrPage(staffMember?.id)
                                                    }}>Edit</button>
                                                    <button
                                                        className={staffMember.status === 'Active' ? `btn-inactive` : `btn-active`}
                                                        onClick={() => {
                                                            setSelectedStaffMemberId(staffMember.id);
                                                            staffMember.status === 'Active' ? setDeactivationModalOpen(true) : setActivateModalOpen(true);
                                                        }
                                                        }>{staffMember.status === 'Active' ? 'Deactivate' : 'Acitvate'}</button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            :
                            <NoResultsFound />
                    }
                </div>
                <div className={`search-card-footer`}>
                    {pageCount > 0 && (
                        <div className={styles.paginationContainer}>
                            <Pagination
                                currentPage={skip + 1}
                                totalPages={pageCount}
                                onPageChange={handlePageChange}
                            />
                        </div>
                    )}
                </div>
            </div>
            {isModalOpen &&
                <div className={`modal-overlay`}>
                    <div className={`modal-card`}>
                        <div className={`modal-header`}>
                            <h4 className={`modal-title`}>Edit Staff Member</h4>
                            <FontAwesomeIcon icon={faXmark} onClick={() => setModalOpen(false)} size="lg" cursor="pointer" />
                        </div>
                        <div className={`modal-body`}>
                            <div className={styles.formContainer}>
                                <form
                                    className={styles.coordinatorForm}
                                    noValidate
                                >
                                    <div className={`form-input-row md-col`}>
                                        <div className={`form-input-group`}>
                                            <label htmlFor='full_name' className={`form-label`}>
                                                Name<span className={`required-star`}>*</span>
                                            </label>
                                            <input
                                                type='text'
                                                id='full_name'
                                                name='full_name'
                                                value={selectedStaffMember.full_name || ''}
                                                onChange={handleSelectedStaffMemberChange}
                                                placeholder='Enter StaffMember Name'
                                                className={`form-input-default`}
                                            />
                                            {editErrorMsgs.full_name && (
                                                <p className={`text-danger`}>{editErrorMsgs.full_name}</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className={`form-input-row md-col`}>
                                        <div className={`form-input-group`}>
                                            <label htmlFor='full_name' className={`form-label`}>
                                                Email<span className={`required-star`}>*</span>
                                            </label>
                                            <input
                                                type='text'
                                                id='email'
                                                name='email'
                                                value={selectedStaffMember.email || ''}
                                                disabled
                                                placeholder='Enter Email'
                                                className={`form-input-default`}
                                            />
                                            {editErrorMsgs.email && (
                                                <p className={`text-danger`}>{editErrorMsgs.email}</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className={`form-input-row md-col`}>
                                        <div className={`form-input-group`}>
                                            <label htmlFor='full_name' className={`form-label`}>
                                                Phone Number<span className={`required-star`}>*</span>
                                            </label>
                                            <input
                                                type='text'
                                                id='phone_number'
                                                name='phone_number'
                                                value={selectedStaffMember.phone_number || ''}
                                                onChange={handleSelectedStaffMemberChange}
                                                placeholder='Enter Phone Number'
                                                className={`form-input-default`}
                                            />
                                            {editErrorMsgs.phone_number && (
                                                <p className={`text-danger`}>{editErrorMsgs.phone_number}</p>
                                            )}
                                            {errorMsg && (
                                                <p className={`text-danger`}>{errorMsg}</p>
                                            )}
                                        </div>
                                    </div>
                                    <button
                                        className={`btn-primary`}
                                        type='button'
                                        disabled={disabledEditBtn}
                                        onClick={editStaffMemberDetails}
                                    >
                                        {isEditingStaffMember ? <BeatLoader color='#ffffff' /> : `Save`}
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            }
            {isActivateModalOpen && (
                <Modal
                    title='Staff Member Activation'
                    onClose={closeModal}
                    onYes={handleYes}
                    isInput={false}
                    iconName={faCircleCheck}
                    bodyText={`Are you sure you want to activate the Staff Member?`}
                    colorType={`var(--green)`}
                />
            )}
            {isDeactivationModalOpen && (
                <Modal
                    title='Staff Member Deactivation'
                    onClose={closDeactivationModal}
                    onYes={handleRejectYes}
                    isInput={false}
                    iconName={faCircleXmark}
                    bodyText={`Are you sure you want to deactivate the Staff Member?`}
                    colorType={`var(--danger)`}
                />
            )}
            {isPasswordModalOpen &&
                <div className={`modal-overlay`}>
                    <div className={`modal-card`}>
                        <div className={`modal-header`}>
                            <h4 className={`modal-title`}>Change Staff Password</h4>
                            <FontAwesomeIcon icon={faXmark} onClick={() => setPasswordModalOpen(false)} size="lg" cursor="pointer" />
                        </div>
                        <div className={`modal-body`}>
                            <div>
                                <form
                                    noValidate
                                >
                                        <>
                                            <div className={`form-input-row md-col`}>
                                                <div className={`form-input-group`}>
                                                    <label htmlFor='password' className={`form-label`}>
                                                        New Password
                                                    </label>
                                                    <div style={{ position: "relative", width: "100%" }}>
                                                        <input
                                                            type={changePasswordVisible ? 'text' : 'password'}
                                                            id='password'
                                                            name='password'
                                                            value={passwordChangeData.password}
                                                            onChange={handlePasswordInputChange}
                                                            placeholder='Enter new password'
                                                            className={`form-input-default`}
                                                        />
                                                        <FontAwesomeIcon
                                                            icon={!changePasswordVisible ? faEyeSlash : faEye}
                                                            onClick={() => setChangePasswordVisible((prev) => !prev)}
                                                            size="lg"
                                                            cursor="pointer"
                                                            style={{
                                                                position: "absolute",
                                                                right: "10px",
                                                                top: "50%",
                                                                transform: "translateY(-50%)",
                                                                cursor: "pointer",
                                                            }}
                                                        />
                                                    </div>
                                                    {passwordChangeError?.password && (
                                                        <p className={`text-danger`}>{passwordChangeError?.password}</p>
                                                    )}
                                                </div>
                                            </div>
                                            <div className={`form-input-row md-col`}>
                                                <div className={`form-input-group`}>
                                                    <label htmlFor='password' className={`form-label`}>
                                                        Confirm Password
                                                    </label>
                                                    <div style={{ position: "relative", width: "100%" }}>
                                                        <input
                                                            type={confirmPasswordVisible ? 'text' : 'password'}
                                                            id='confirm_password'
                                                            name='confirm_password'
                                                            value={passwordChangeData.confirm_password}
                                                            onChange={handlePasswordInputChange}
                                                            placeholder='Enter confirm password'
                                                            className={`form-input-default`}
                                                        />
                                                        <FontAwesomeIcon
                                                            icon={!confirmPasswordVisible ? faEyeSlash : faEye}
                                                            onClick={() => setConfirmPasswordVisible((prev) => !prev)}
                                                            size="lg"
                                                            cursor="pointer"
                                                            style={{
                                                                position: "absolute",
                                                                right: "10px",
                                                                top: "50%",
                                                                transform: "translateY(-50%)",
                                                                cursor: "pointer",
                                                            }}
                                                        />
                                                    </div>
                                                    {passwordChangeError?.confirm_password && (
                                                        <p className={`text-danger`}>{passwordChangeError?.confirm_password}</p>
                                                    )}
                                                </div>
                                            </div>
                                        </>
                                    <button
                                        className={`btn-primary`}
                                        type='button'
                                        disabled={disabledPasswordBtn}
                                        onClick={handleChangeStaffPassword}
                                    >
                                        {disabledPasswordBtn ? <BeatLoader color='#ffffff' /> : `Reset Password`}
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    );
};

export default Staff;